import CountryPageRenderer from '../components/CountryPageRenderer';
import greeceData from '../data/country-pages/greece';

export default function GreeceCountryPage() {
  return <CountryPageRenderer data={greeceData} />;
}
